import { render } from "./layout.vue?vue&type=template&id=4b12ac1f&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=4b12ac1f&lang=scss&scoped=true"

import exportComponent from "E:\\4-6 项目\\蚂蚁电能交易分析\\energy\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b12ac1f"]])

export default __exports__